import { render, staticRenderFns } from "./ManageLabels.vue?vue&type=template&id=e429d47e&scoped=true"
import script from "./ManageLabels.vue?vue&type=script&lang=js"
export * from "./ManageLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e429d47e",
  null
  
)

export default component.exports